import Number from './NumberInputForm';
import Password from './PasswordInputForm';
import Text from './TextInputForm';
import Select from './SelectInputForm';
import Checkbox from './CheckboxInputForm';
import Field from './FieldInputForm';
import Switch from './SwitchElem';


export default { Number, Password, Text, Select, Checkbox, Field, Switch,  };
